var factsheetHeader = {
	label: {
		highLowBar: "Intraday Spanne",
		lastPriceDateTime: "Datum/Zeit:",
		volume: "Volumen:",
		isin: "ISIN",
		wkn: "WKN",
		numberOfConstituents: "Anzahl der enthaltende Werte",
		country: "Land",
		symbol: "Symbol",
		fundIssuer: "Emittent",
		fundCategory: "Kategorie",
		pea: "PEA",
		pme: "PEA-PME",
		srd: "SRD",
		tradingStatus: "Handelsstatus",
		perf1Year: "Perf. 1 Jahr",
		perf5Years: "Perf. 5 Jahre",
		perf1Week: "Perf. 1 Woche",
		perf1Month: "Perf. 1 Monat",
		suspended: "Ausgesetzt",
		marketStatus: "Marktstatus",
		tradingPhase: "Handelsphase",
		expectedDividends: "Erwartete Dividenden",
		expectedPriceEarningsRatio: "Erwartetes Kurs-Gewinn-Verhältnis"
	},
	"true": "Ja",
	"false": "Nein",
	open: "Offen",
	close: "Geschlossen"
};
var de = {
	factsheetHeader: factsheetHeader
};

export { de as default, factsheetHeader };
